import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';

interface PopOverContentProperties {
  openPopover: boolean;
  popOverContent: JSX.Element | string;
  version?: string;
}

const PopOverContent = forwardRef<HTMLDivElement, PopOverContentProperties>(function PopOverContent(
  { openPopover, popOverContent,version },
  popoverReference,
) {
  return openPopover
    ? ReactDOM.createPortal(
        <div className={`pop-over-content-wrap-${version}`}>
          <div className="pop-over-content-container" ref={popoverReference}>
            {popOverContent}
          </div>
        </div>,
        document.body,
      )
    : null;
});
PopOverContent.defaultProps = {
version: 'v1',
}
export default PopOverContent;
